export const LibelleLogement = {
  // lieuResidence
  residence_list: [
    {code: "APPARTEMENT_OU_MAISON", libelle: "Appartement ou maison"},
    {code: "LOGEMENT_CROUS", libelle: "Logement CROUS"},
    {code: "FOYER", libelle: "Foyer"},
    {code: "CHAMBRE", libelle: "Chambre"},
    {code: "RESIDENCE_SOCIALE_FJT", libelle: "Résidence sociale/FJT"},
    {code: "MAISON_RETRAITE_EHPAD", libelle: "Maison de retraite/EPHAD"}
  ],
  // typeOccupation    
  appart_detail_list: [
    {code: "LOCATION", libelle: "En location"},
    {code: "COLOCATION", libelle: "En colocation"}
  ],
  // typeCrous    
  crous_detail_list: [
    {code: "CHAMBRE", libelle: "Chambre"},
    {code: "CHAMBRE_REHABILITEE", libelle: "Chambre Réhabilitée"},
    {code: "STUDIO", libelle: "Studio"}
  ], 
  // Est Meublé
  choix_list: [
    {code: "true", libelle: "Oui"},
    {code: "false", libelle: "Non"}
  ],    
  // Est Conventionne
  choix_conventionne_list: [
    {code: "true", libelle: "Oui"},
    {code: "false", libelle: "Non"},
    {code: "SAIS_PAS", libelle: "Je ne sais pas"}
  ],    
  type_montant_list: [
    {id: "14", code: "MONTANT_LOYER", libelle: "Montant mensuel de votre loyer"},
    {id: "15", code: "MONTANT_CHARGE", libelle: "Montant mensuel de votre loyer (charges comprises)"},
    {id: "16", code: "MONTANT_HORS_CHARGE", libelle: "Montant mensuel de votre loyer (hors charges)"},
    {id: "17", code: "PART_MONTANT_CHARGE", libelle: "Part de votre loyer mensuel (charges comprises)"},
    {id: "18", code: "PART_MONTANT_HORS_CHARGE", libelle: "Part de votre loyer mensuel (hors charges)"},
    {id: "19", code: "MONTANT_REDEVANCE", libelle: "Montant mensuel de votre redevance"}    
  ],    
  situation_familiale_list: [
    {code: "CEL", libelle: "Seul(e)"},
    {code: "VIM", libelle: "En couple"}
  ]

}